module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.curPage) ? _c('ul', {
    staticClass: "paging"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changePage(_vm.page.curPage - 1)
      }
    }
  }, [_c('a', {
    class: {
      'disabled': _vm.page.curPage == 1
    },
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../images/personal_center/collection-left.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _vm._l((_vm.initPage), function(item) {
    return _c('li', {
      class: {
        'active': _vm.page.curPage == item,
        'apostrophe': item == '...'
      },
      attrs: {
        "name": "page-body"
      },
      on: {
        "click": function($event) {
          return _vm.changePage(item)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item))])])
  }), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changePage(_vm.page.curPage + 1)
      }
    }
  }, [_c('a', {
    class: {
      'disabled': _vm.page.curPage == _vm.page.totalPage
    },
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../images/personal_center/collection-right.png"),
      "alt": ""
    }
  })])])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-cf901bea!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/page.vue
// module id = hrf+
// module chunks = 15